import React, { useEffect } from "react";
import "./App.css";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ScrollToTop from "./components/scroll-to-top";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
// import Loader from "react-dots-loader";
import "react-dots-loader/index.css";
import { setModalState } from "./redux/actions/modalActions";
import { Backdrop } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ModalProvider from "./components/modal/modal";
// import loader from "./assets/loader.gif";

function App() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);

  useEffect(() => {
    dispatch(setModalState(undefined));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ToastContainer />
        <ModalProvider />
        <ScrollToTop />
        {isLoading && (
          <div className="loader">
            <Backdrop sx={{ zIndex: 4000 }} open={true}>
              <div class="container">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </Backdrop>
          </div>
        )}

        <React.Suspense
          fallback={
            <div className="over-lay">
              <div>
                <span>Loading</span>
              </div>
            </div>
          }
        >
          <Router />
        </React.Suspense>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
